const ReportsRoutes = [
	{
		path: '/sales-report',
		name: 'sales-report',
		component: () => import('@/components/sales/SalesLayout.vue'),
		redirect: '/item',
		children: [
			//Item Report
			{
				path: '/item',
				name: 'item',
				component: () => import('@/components/sales/Item.vue'),
			},

			//Item Report
			{
				path: '/payments',
				name: 'payments',
				component: () => import('@/components/sales/Payments.vue'),
			},

			{
				path: '/packages',
				component: () => import('@/components/default'),
				children: [
					{
						path: '',
						name: 'packages',
						component: () => import('@/components/sales/Packages.vue'),
					},
					{
						path: ':id?',
						name: 'package-details',
						component: () => import('@/components/sales/PackageDetails'),
					},
				],
			},

			{
				path: '/credit-notes',
				name: 'credit-notes',
				component: () => import('@/components/sales/CreditNotes.vue'),
			},

			//SalesLocation Report
			{
				path: '/location',
				name: 'location',
				component: () => import('@/components/sales/SalesLocation.vue'),
			},

			//Sales Category Report
			{
				path: '/category',
				name: 'category',
				component: () => import('@/components/sales/SalesCategory.vue'),
			},

			//Sales Customer Report
			{
				path: '/customer-sales',
				name: 'customer-sales',
				component: () => import('@/components/sales/SalesCustomer.vue'),
			},
		],
	},

	//Sales Report
	{
		path: '/report',
		name: 'report',
		component: () => import('@/components/reports/SalesReport.vue'),
	},

	//Invoices Report
	{
		path: '/invoices',
		name: 'invoices',
		component: () => import('@/components/sales/InvoicesReports.vue'),
	},

	//Invoices Details Report
	{
		path: '/invoice-details',
		name: 'invoice-details',
		component: () => import('@/components/sales/InvoiceDetails.vue'),
	},

	//Inventory Report
	{
		path: '/inventory-reports',
		name: 'inventory-reports',
		component: () => import('@/components/reports/InventoryReports.vue'),
	},

	//WaybillsReport Report
	{
		path: '/waybills-reports',
		name: 'waybills-reports',
		component: () => import('@/components/reports/WaybillsReport.vue'),
	},

	//Purchased Report
	{
		path: '/purchased-order-reports',
		name: 'purchased-order-reports',
		component: () => import('@/components/reports/PurchasedOrderReport.vue'),
	},
	// Purchased Order Report
	{
		path: '/purchased-order-report-preview',
		name: 'purchased-order-report-preview',
		component: () =>
			import('@/components/reports/PurchasedOrderReportPreview.vue'),
	},

	// Purchased Order Report
	{
		path: '/products-management',
		name: 'products-management',
		component: () => import('@//components/inventory/ProductsManagement.vue'),
	},
];

export default ReportsRoutes